import { Button } from "@/components/ui";
import { useStartAsyncEncounter } from "@/features/Patient/network/useStartAsyncEncounter";
import { DistributionAction } from "@/network/useAvailableActions";
import { useAvailableActions } from "@/network/useAvailableActions";
import { useParams, useSearch } from "@tanstack/react-router";

export const StartNote = () => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const { encounterId } = useSearch({ from: "/patient/$patientId" });
  const { mutate: startAsyncEncounter, isPending } = useStartAsyncEncounter();

  const { data: actions } = useAvailableActions({
    patientId,
    encounterId: encounterId as string | undefined,
  });

  if (encounterId) {
    return null;
  }

  if (!actions?.[DistributionAction.START_CLINICAL_NOTE]?.allowed) {
    return null;
  }

  return (
    <Button
      variant="primary"
      size="xs"
      onClick={() => {
        startAsyncEncounter();
      }}
      isLoading={isPending}
    >
      Start Async Note
    </Button>
  );
};
